import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormattedMessage } from 'react-intl';
import noData from '../../../style/animations/nodata.json';
import Lottie from 'lottie-react';
import { useTheme } from '@material-ui/core';
import { ReactComponent as NoDataIcon } from '../../../assets/nodata.svg';

const styles = ((theme) => ({
  noData: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    fontSize: 16,
  },
  noDataIcon: {
    maxWidth: 80,
    marginTop: 40,
    fill: theme.palette.text.secondary,
  },
}));

const noDataStyles = { marginTop: 20, width: 120, height: 120, fontWeight: 500 };

const NoDataAvailableWithIcon = ({ classes, customText }) => {
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';
  
  return <div className={classes.noData}>
    {customText || <FormattedMessage id="report.title.NoDataFoundForGivenRange"
                                     defaultMessage="No data available for the given range" />}
    
    {isLight ? <Lottie
      loop={false}
      animationData={noData}
      style={noDataStyles}
    /> : <NoDataIcon className={classes.noDataIcon} />}
  </div>;
};

export default withStyles(styles)(NoDataAvailableWithIcon);
